export default "images/florida.png";